import { Card } from "antd";
import React from "react";

function LoksevaAdhiniyam() {
  return (
    <Card title="लोकसेवा हक्क अधिनियम 2015">
      <h3>
        <a
          style={{ color: "#0d6efd", fontSize: 16 }}
          target="_blank"
          href="https://pskagal.in/api/uploads/lokseva/2015-31.pdf"
        >
          महाराष्ट्र लोकसेवा हक्क अधिनियम 2015
        </a>
      </h3>
    </Card>
  );
}

export default LoksevaAdhiniyam;
